<template>
  <card id="endDeviceActivation" :title="$t('ed-activation:activation') + ` ${endDevice.activation}`" no-body no-footer>
    <table slot="card-table" class="table table-sm table-ellipsis mb-0">
      <tbody>
        <tr>
          <td class="text-uppercase">{{ $t('ed-activation:devAddr') }}</td>
          <td>{{ endDevice.devAddr }}</td>
        </tr>

        <tr v-if="endDevice.activation==='OTAA'">
          <td class="text-uppercase">{{ $t('ed-activation:appEui') }}</td>
          <td>{{ endDevice.appEui }}</td>
        </tr>
        <tr v-if="endDevice.activation==='OTAA'">
          <td class="text-uppercase">{{ $t('ed-activation:appKey') }}</td>
          <td>{{ endDevice.appKey }}</td>
        </tr>
        <tr v-if="endDevice.activation==='OTAA' && isLoRaWan10">
          <td class="text-uppercase">{{ $t('ed-activation:devNonceCounter') }}</td>
          <td>{{ $t('ed-activation:'+endDevice.devNonceCounter) | capitalize }}</td>
        </tr>

        <tr v-if="endDevice.activation==='ABP'">
          <td class="text-uppercase">{{ $t('ed-activation:appSKey') }}</td>
          <td>{{ endDevice.appSKey }}</td>
        </tr>
        <tr v-if="endDevice.activation==='ABP'">
          <td class="text-uppercase">{{ $t('ed-activation:nwkSKey') }}</td>
          <td>{{ endDevice.nwkSKey }}</td>
        </tr>
      </tbody>
    </table>
  </card>
</template>

<script>
export default {
  props: {
    endDevice: {
      type: Object,
      required: true
    }
  },

  computed: {
    // DevNonceCounter only for 1.0 version
    isLoRaWan10 () {
      return this.endDevice.macVersion && this.endDevice.macVersion.indexOf('1.0') !== -1
    }
  }
}
</script>
